import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Component that tracks page views as the user navigates through the app
 * This component doesn't render anything visible - it just tracks analytics
 */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    trackPageView(location.pathname);
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default AnalyticsTracker;